export enum TravelType {
  Hotel = 'Hotel',
  Flight = 'Flight',
  ExtraCharge = 'ExtraCharge',
  Vehicle = 'Vehicle',
}
